<template>
  <div>
    <hide-at :breakpoints="{small: 767, medium: 768, large: 1024}" breakpoint="mediumAndAbove">
        <div>
            <b-nav id="mobileNavBarReport" class="mobile-sub-nav fixed-top scrollable">
                <div>
                    <b-link href="#" @click="mostraPaginaIlluminazione" :class="{current: this.devicesType == '' || this.devicesType == null || this.devicesType == 'illuminazione'}">{{$t("navbar_dispositivi.lighting")}}</b-link>
                    <b-link href="#" @click="mostraPaginaEmergenza" :class="{current: this.devicesType == 'emergenza'}">{{$t("navbar_dispositivi.emergency")}}</b-link>
                    <b-link href="#" @click="mostraPaginaMains" :class="{current: this.devicesType == 'mains'}">{{$t("mains")}} </b-link>
                </div>
            </b-nav>
        </div>
    </hide-at>
    <show-at :breakpoints="{small: 767, medium: 768, large: 1024}" breakpoint="mediumAndAbove">
      <nav class="pl-3 pt-1 fixed-top navbar-illum">
        <b-button
        :pressed="btn_state_lighting"
        class="typo-label"
        variant="link"
        @click="mostraPaginaIlluminazione"
      >{{$t("navbar_dispositivi.lighting")}}</b-button>
        <b-button
          :pressed="btn_state_emergency"
          class="typo-label"
          variant="link"
          @click="mostraPaginaEmergenza"
        >{{$t("navbar_dispositivi.emergency")}}</b-button>
        <b-button
          :pressed="btn_state_mains"
          class="typo-label"
          variant="link"
          @click="mostraPaginaMains"
        >{{$t("mains")}}</b-button>
      </nav>
    </show-at>
  </div>

</template>

<script>
import {showAt, hideAt} from 'vue-breakpoints'

export default {
  name: "NavBarReport",
  components: {
    showAt,hideAt
  },
  data() {
    return {
      devicesType: ''
    };
  },
  mounted() {
    // 1. Get the type from the route
    let routeDevType = this.$router.currentRoute.params.devicesType;
    console.log("MOUNTED NavBarReport devicesType from route:", routeDevType);

    // 2. Set the initial state based on the route or default to 'illuminazione'
    if (routeDevType) {
      this.devicesType = routeDevType;
    } else {
      this.devicesType = 'illuminazione';
    }

    // 3. Force the router to the 'illuminazione' route if the type is missing or incorrect in the URL.
    // This handles the case where the user navigates to the parent route without a devicesType param.
    // if (!routeDevType || routeDevType !== 'illuminazione') {
    //   console.log("ROUTE FIXUP TO ILLUMINAZIONE");
    //   this.mostraPaginaIlluminazione();
    // }
  },
  computed: {
    btn_state_emergency() {
      return this.devicesType == 'emergenza';
    },
    btn_state_lighting() {
      return this.devicesType == 'illuminazione' || this.devicesType == null || this.devicesType == '';
    },
    btn_state_mains() {
      return this.devicesType == 'mains';
    }
  },
  watch: {
    '$route'() {
        // TODO: react to navigation event.
        // params cotains the current route parameters
        console.log("route changed 2!",this.$route.params);
        this.devicesType = this.$route.params["devicesType"];
        this.$forceUpdate();
    },
  },
  methods: {
    mostraPaginaMains() {
      const parametri = {
        plantId: this.$store.state.currentPlant.id,
        devicesType: 'mains'
      };
      const currentRoute = this.$route;
      if ((JSON.stringify(currentRoute.params) != JSON.stringify(parametri))) {
        this.$router.push({
          name: "ReportMains",
          params: parametri
        });
      }
    },

    mostraPaginaEmergenza() {
      const parametri = {
        plantId: this.$store.state.currentPlant.id,
        devicesType: 'emergenza'
      };
      const currentRoute = this.$route;
      if ((JSON.stringify(currentRoute.params) != JSON.stringify(parametri))) {
        this.$router.push({
          name: "ReportImpianto",
          params: parametri
        });
      }
    },

    mostraPaginaIlluminazione() {
        const targetDevicesType = 'illuminazione';
        console.log("mostraPaginaIlluminazione currentPlant:", this.$store.state.currentPlant);

        // Check if the current route already points to 'illuminazione'
        if (this.$route.params.devicesType !== targetDevicesType) {
            this.$router.push({
                name: "ReportImpianto",
                params: { plantId: this.$store.state.currentPlant.id, devicesType: targetDevicesType }
            });
        }
        // CRITICAL: Update the data property immediately for reactive styling
        this.devicesType = targetDevicesType;
    }
  }
};
</script>
